<app-layer-config-collapsible-category
  class="border-bottom border-darkgray"
  description="Sign Types"
  storageKey="vzo-sign-types"
  [collapsedDefault]="false"
>
  <div class="d-flex flex-column gap-1 pb-1" style="max-width: 300px">
    <div
      class="d-flex justify-content-between align-items-center fs-2xs text-gray ho-layer-item rounded-2 px-0 py-0"
      aria-label="Toggle sign types"
    >
      <div class="d-flex align-items-center gap-2">
        <span>Selected</span>
        <span>{{ selectedCount }} / {{ totalCount }}</span>
      </div>
    </div>

    <div class="d-flex flex-wrap gap-1">
      @for (signType of signTypes; track signType) {
        <button
          type="button"
          class="sign-type-button rb-btn border rounded-2 p-0 ho-layer-item bg-dark position-relative"
          style="width: 38px; height: 38px"
          [class.sel-menu-item]="isSelected(signType)"
          [class.text-gray]="!isSelected(signType)"
          [class.border-darkgray]="!isSelected(signType)"
          (click)="toggleSignType(signType)"
          [attr.aria-label]="signType"
          [attr.title]="signType"
        >
          <span
            class="position-absolute top-50 start-50 translate-middle d-inline-flex align-items-center justify-content-center"
          >
            <app-sprite-image
              [iconName]="getChipIconName(signType)"
              [type]="'small'"
            ></app-sprite-image>
          </span>
        </button>
      }
    </div>
  </div>
</app-layer-config-collapsible-category>
